import React from "react";
import { TabNavigationProps } from "./types";

const TabNavigation: React.FC<TabNavigationProps> = ({
  activeTab,
  onTabChange,
}) => {
  const tabs = [
    { id: "overall", label: "Overall Performance" },
    // { id: "core", label: "Core Competencies" },
    { id: "detailed", label: "Question and Improved Response" },
    // { id: "development", label: "Development(Study) Plan" },
    { id: "analysis", label: "Detailed Case Component Analysis" },
    // { id: "feedback", label: "Feedback" },
  ];

  return (
    <div className="flex bg-[#F8F9FA] px-6">
      <div className="flex border-b w-full">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`px-4 py-3 border-b-2 transition-colors duration-200 font-product-sans ${
              activeTab === tab.id
                ? "border-[var(--color-primary)] text-[var(--color-primary)]"
                : "border-transparent text-gray-500 hover:text-[var(--color-primary)]"
            }`}
            onClick={() => onTabChange(tab.id as any)}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default TabNavigation;
